import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Time, Util} from 'yougile-util'
import {
  stickerDeadlineAsStatisticsDatesProperty,
  stickerDeadlineNoClearFilterProperty,
  SystemStickerType
} from 'yougile-model'
import {DateRangePicker} from '@components/common/date-picker-old/date-range-picker'
import {StickerMenuHeader} from '@components/sticker/sticker-menu/sticker-menu-header'
import {useStickerStore} from '@components/sticker/sticker-store'
import {Gantt} from '@extensions/gantt'
import {Task} from '@extensions/task'

export const StickerMenuDeadlinePanel = observer(() => {
  const [state, store] = useStickerStore()

  const initialDates: [Date, Date] | undefined =
    state.filterValues?.length === 2
      ? [
          Time.toLocalDate(+state.filterValues[0]),
          Time.toLocalDate(+state.filterValues[1])
        ]
      : undefined
  const isStatisticsFilter =
    !!store.sticker.properties[stickerDeadlineAsStatisticsDatesProperty]
  const noFilterClear =
    !!store.sticker.properties[stickerDeadlineNoClearFilterProperty]
  const showRemoveFilter = state.filterValues?.length === 2 && !noFilterClear
  const bem = Util.bemFrom('sticker-item-list')

  const clearFilter = () => {
    store.setFilters([])
  }

  const onChoose = (range: [Date, Date]) => {
    store.setFilters([
      `${Time.toTimestamp(range[0])}`,
      `${Time.toTimestamp(range[1])}`
    ])
  }

  const forbidUnpin =
    Task.shouldAutoPlan(store.stickerTask) &&
    (Gantt.getLinkedFromHubs(store.stickerTask).length > 0 ||
      Gantt.getLinksToHubs(store.stickerTask).length > 0)

  return (
    <div className="w-[233px]">
      <div className="sticker-item-list-head flex">
        <StickerMenuHeader
          stickerId={store.sticker.id}
          title={
            isStatisticsFilter
              ? store.sticker.title
              : Lang.msg.stickerNames[
                  store.stickerData.stickerType as SystemStickerType
                ]
          }
          showUnpin={!forbidUnpin}
        />
      </div>
      <div className="sticker-item-list-body">
        {!isStatisticsFilter && (
          <>
            <div className={bem('header')}>{Lang.msg.boardFiltration}</div>
            {!showRemoveFilter && (
              <div className={bem('header-hint')}>
                {Lang.msg.stickerPanel.deadlineFilterHint}
              </div>
            )}
          </>
        )}

        {showRemoveFilter && (
          <div className="sticker-deadline-clear" onClick={clearFilter}>
            {Lang.msg.boardRemoveFilter}
          </div>
        )}
        <DateRangePicker
          onChoose={onChoose}
          initialDates={initialDates}
          disallowChooseFutureDates={isStatisticsFilter}
          disallowDatesBefore={isStatisticsFilter ? '2018-08-19' : undefined}
        />
      </div>
    </div>
  )
})
